import './_message.scss';
import VStore from "../../store";

export default function Message() {
    const {message, sendMessage} = VStore();
    function closeMessage() {
        sendMessage('');
    }

    return message !== '' ? <div className="message">
        <div className='message__background'
             onClick={closeMessage}
        ></div>
        <div className='message__content'>
            <button className='message__content__close-btn'
                    onClick={closeMessage}
            >
                &times;
            </button>
            <span>{message}</span>
        </div>
    </div> : <></>
}
